/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAssociateCustomerResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createReassignCustomerResponseFromDiscriminatorValue, createRevokeCustomerAccessResponseFromDiscriminatorValue, serializeAssociateCustomerRequest, serializeAssociateCustomerResponse, serializeReassignCustomerRequest, serializeReassignCustomerResponse, type AssociateCustomerRequest, type AssociateCustomerResponse, type ErrorResponse, type InternalErrorResponse, type ReassignCustomerRequest, type ReassignCustomerResponse, type RevokeCustomerAccessResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/users/associate-customer
 */
export interface AssociateCustomerRequestBuilder extends BaseRequestBuilder<AssociateCustomerRequestBuilder> {
    /**
     * Removes a storefront user's access to one customer in the caller's organization. Keyed on the user id and customer number, never on the internal association id. Idempotent: an association that is already gone returns 200 with removed = false. An active storefront session keeps its access until its token expires.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RevokeCustomerAccessResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<AssociateCustomerRequestBuilderDeleteQueryParameters> | undefined) : Promise<RevokeCustomerAccessResponse | undefined>;
    /**
     * Associates a user with a customer in the system
     * @param body Grants one storefront user access to one customer in the caller's organization.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AssociateCustomerResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: AssociateCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AssociateCustomerResponse | undefined>;
    /**
     * Moves a storefront user from one customer to another in the caller's organization, replacing the association rather than adding a second one. The target customer must exist in the organization and the source must be an association the organization holds. Reassigning to the customer the user already shops for returns 200 with reassigned = false. An active storefront session keeps the old customer until its token expires.
     * @param body Moves one storefront user from the customer they can shop for to a different one.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ReassignCustomerResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: ReassignCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ReassignCustomerResponse | undefined>;
    /**
     * Removes a storefront user's access to one customer in the caller's organization. Keyed on the user id and customer number, never on the internal association id. Idempotent: an association that is already gone returns 200 with removed = false. An active storefront session keeps its access until its token expires.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<AssociateCustomerRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
    /**
     * Associates a user with a customer in the system
     * @param body Grants one storefront user access to one customer in the caller's organization.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AssociateCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Moves a storefront user from one customer to another in the caller's organization, replacing the association rather than adding a second one. The target customer must exist in the organization and the source must be an association the organization holds. Reassigning to the customer the user already shops for returns 200 with reassigned = false. An active storefront session keeps the old customer until its token expires.
     * @param body Moves one storefront user from the customer they can shop for to a different one.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: ReassignCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Removes a storefront user's access to one customer in the caller's organization. Keyed on the user id and customer number, never on the internal association id. Idempotent: an association that is already gone returns 200 with removed = false. An active storefront session keeps its access until its token expires.
 */
export interface AssociateCustomerRequestBuilderDeleteQueryParameters {
    /**
     * The customer the user should no longer be able to shop for. Matched case-insensitively.Required; a missing or empty value is rejected.
     */
    customerNumber?: string;
    /**
     * The identity provider user id whose access is being revoked — the UserId thestorefront-users listing returns. Required; a missing or empty value is rejected.
     */
    userId?: string;
}
/**
 * Uri template for the request builder.
 */
export const AssociateCustomerRequestBuilderUriTemplate = "{+baseurl}/api/organizations/users/associate-customer{?customerNumber*,userId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const AssociateCustomerRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: AssociateCustomerRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRevokeCustomerAccessResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: AssociateCustomerRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createAssociateCustomerResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAssociateCustomerRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: AssociateCustomerRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createReassignCustomerResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReassignCustomerRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
